module.exports = __webpack_public_path__ + "img/ts6.4320b833.png";